const getRecipeUrl = (id: string | null, isNewFile: boolean = false) => `/flow/${id}${isNewFile ? '?new=true' : ''}`;

export const goToRecipe = (id: string | null, openInNewTab: boolean = false, isNewFile: boolean = false) => {
  if (!id) {
    return;
  }
  const url = getRecipeUrl(id, isNewFile);
  if (openInNewTab) {
    window.open(url, '_blank');
  } else {
    window.location.href = url;
  }
};
